import React, { useMemo } from 'react'
import styles from './markdownpreview_styles'
import injectSheet from 'react-jss'
import Space from 'material/space/space'
import { ReactComponent as ChatWarningIcon } from 'assets/icons/chat-warning.svg'
import { ReactComponent as Comment } from './imgassets/author-comments-count.svg'

const escapeHtml = (unsafe) => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

const parseMd = (input) => {
  let md = input
  md = md.replace(/^[\#]{6}(.+)$/gm, '<h6>$1</h6>')
  md = md.replace(/^[\#]{5}(.+)$/gm, '<h5>$1</h5>')
  md = md.replace(/^[\#]{4}(.+)$/gm, '<h4>$1</h4>')
  md = md.replace(/^[\#]{3}(.+)$/gm, '<h3>$1</h3>')
  md = md.replace(/^[\#]{2}(.+)$/gm, '<h2>$1</h2>')
  md = md.replace(/^[\#]{1}(.+)$/gm, '<h1>$1</h1>')
  md = md.replace(/[\*\_]{2}([^\*\_]+)[\*\_]{2}/g, '<b>$1</b>')
  md = md.replace(/[\*\_]{1}([^\*\_]+)[\*\_]{1}/g, '<i>$1</i>')
  md = md.replace(/[\[]{1}([^\]]+)[\]]{1}[\(]{1}([^\)\"]+)(\"(.+)\")?[\)]{1}/g, '<a href="$2" target="_blank" title="$4">$1</a>')
  return md
}

const countLeadingHashes = (str) => {
  if (str.startsWith('#')) {
    return 1 + countLeadingHashes(str.slice(1));
  }
  return 0;
}

const MarkdownPreview = injectSheet(styles)(({ value, classes, heading, isV2 }) => {
  const markdownHtml = useMemo(() => {
    const parsedMessage = parseMd(escapeHtml(value))
    const messageWithLineBreaks = parsedMessage.replace(/\n/g, '<br />')
    return messageWithLineBreaks
  }, [value])

  const iconProps = useMemo(() => {
    const firstHeadingNumber = countLeadingHashes(value)
    const iconScale = {
      1: '1.3',
      2: '1.2'
    }
    const iconMargin = {
      1: '1.3em',
      2: '0.5em'
    }
    return {
      margin: iconMargin[firstHeadingNumber] || '0',
      scale: iconScale[firstHeadingNumber] || '1'
    }
  }, [value])

  return <div className={classes.content}>
    {!isV2 ? (
      <>
        <span className='icon' style={{ margin: `${iconProps.margin} 0`, transform: `scale(${iconProps.scale})` }} >
          <Comment />
        </span>
        <span className='text'>
          <span dangerouslySetInnerHTML={{ __html: markdownHtml }} />
        </span>
      </>
    ) :(
    <div className='markdownpreview-v2'>
      <Space justifyContent={'space-between'}>
        <div>
          {heading && <h4 className='heading'>{heading}</h4>}
          <span className='text'>
            <span dangerouslySetInnerHTML={{ __html: markdownHtml }} />
          </span>
        </div>
        {isV2 && (
          <span className={'iconwrapper'}>
            <ChatWarningIcon />
          </span>
        )}
      </Space>
    </div>
    )}
  </div>
})

export default MarkdownPreview